import React, { useState } from 'react';
import { Volume2 } from 'lucide-react';
import { setSoundEnabled, soundPreferenceKnown } from '../../context/AppContext';
import { playTest, unlockAudio } from '../../lib/sound';
import { Dialog, DialogContent, DialogHeader, DialogTitle, DialogDescription } from '../ui/dialog';
import { Button } from '../ui/button';

export function SoundGate() {
  const [open, setOpen] = useState(!soundPreferenceKnown());
  if (!open) return null;
  const choose = (on) => {
    setSoundEnabled(on);
    if (on) { unlockAudio(); playTest(0.55); }
    setOpen(false);
  };
  return (
    <Dialog open={open} onOpenChange={(o) => { if (!o) choose(false); }}>
      <DialogContent className="bg-kelate-surface border-kelate-line max-w-sm" data-testid="sound-gate-modal">
        <DialogHeader>
          <div className="mx-auto mb-2 flex h-12 w-12 items-center justify-center rounded-full bg-secondary">
            <Volume2 size={22} className="text-kelate-wood" />
          </div>
          <DialogTitle className="text-center text-kelate-ink">Enable notification sounds?</DialogTitle>
          <DialogDescription className="text-center text-kelate-soft">
            Receive instant alerts for new orders and important activity.
          </DialogDescription>
        </DialogHeader>
        <div className="flex flex-col gap-2 pt-2">
          <Button data-testid="enable-sound-btn" onClick={() => choose(true)} className="bg-kelate-darkwood text-kelate-surface hover:bg-kelate-wood">
            Enable Sound
          </Button>
          <Button data-testid="not-now-sound-btn" variant="ghost" onClick={() => choose(false)} className="text-kelate-soft">
            Not Now
          </Button>
        </div>
      </DialogContent>
    </Dialog>
  );
}
